import { normalizeLatexExpression } from './normalize';

export interface MathCommitInput {
  /** The expression the document holds. */
  readonly stored: string;
  /** What the math field reads when the teacher closes it. */
  readonly draft: string;
  /** Whether the teacher produced any input since the field opened. */
  readonly edited: boolean;
}

export type MathCommitDecision =
  | { readonly kind: 'keep' }
  | { readonly kind: 'discard' }
  | { readonly kind: 'save'; readonly expression: string };

const KEEP: MathCommitDecision = { kind: 'keep' };
const DISCARD: MathCommitDecision = { kind: 'discard' };

/**
 * What closing a math field does to the document. An untouched field never reads its draft: the
 * field can blank or re-serialize LaTeX it cannot parse, and that must not replace what the teacher has.
 */
export function decideMathCommit({ stored, draft, edited }: MathCommitInput): MathCommitDecision {
  const storedExpression = normalizeLatexExpression(stored);
  if (!edited) return storedExpression ? KEEP : DISCARD;

  const draftExpression = draft.trim();
  if (!draftExpression) return DISCARD;
  if (draftExpression === storedExpression) return KEEP;
  return { kind: 'save', expression: draftExpression };
}
